import { LogOut, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useCompany } from "@/context/CompanyContext";
import { useDepot } from "@/context/DepotContext";
import { CompanyLogo } from "@/components/BrandMark";
import { OwnerBanner } from "@/components/OwnerBanner";
import { BillingPanel } from "./BillingPanel";

const TITLES = {
  trial_ended: "Your 30-day free trial has ended",
  payment_failed: "Your card payment didn't go through",
  plan_ended: "Your plan has ended",
};

// Replaces the office dashboard while a company has no active plan. Crew keep clocking on from their phones.
export const LockedScreen = () => {
  const { logout } = useAuth();
  const { company } = useCompany();
  const { isAdmin } = useDepot();
  return (
    <div className="min-h-screen bg-background" data-testid="billing-locked-screen">
      <OwnerBanner />
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <CompanyLogo />
          <Button variant="ghost" size="sm" onClick={logout} className="rounded-full" data-testid="locked-logout-btn"><LogOut className="w-4 h-4 mr-1.5" /> Sign out</Button>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12 space-y-8">
        <div>
          <span className="inline-flex w-11 h-11 rounded-full bg-primary/10 text-primary items-center justify-center mb-4"><Lock className="w-5 h-5" /></span>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="locked-title">{TITLES[company?.billing?.reason] || "Your plan isn't active"}</h1>
          <p className="mt-3 text-muted-foreground">Pick a plan to open the office dashboard again. Your jobs, rosters and timesheets are all kept, and your crew can still clock on.</p>
        </div>
        {isAdmin ? <BillingPanel /> : (
          <p className="rounded-lg border border-border p-4 text-sm" data-testid="locked-ask-admin">Ask whoever runs your company&apos;s Cross Jobs account to sign in with the company login and pick a plan.</p>
        )}
      </main>
    </div>
  );
};
